import type { Scan } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";

/** Which section of the app the scan is reviewed under; decides the wording and where cancel returns. */
export type EditScanKind = "customer" | "shop";
/** `?mode=`; only the primary button's label differs, since all three run the same confirm. */
export type EditScanMode = "edit" | "review" | "approve";
export type EditScanStatus = "loading" | "ready" | "notFound" | "error";

export class EditScanState {
  readonly noMatch = new Rx<Scan | null>(null);
  readonly status = new Rx<EditScanStatus>("loading");

  constructor(
    readonly kind: EditScanKind,
    readonly mode: EditScanMode,
  ) {}
}

export abstract class EditScanActions {
  abstract cancel(): void;
  abstract retry(): void;
}
